// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1_hQO","cls2":"ToolsMenu-cls2_cVm ToolsMenu-cls1_hQO"};